import { Search } from '@/DTOS/WorkPlace/Search';
import request from '../../utils/request';

const WorkPlaceService = {
  search: (search: Search) => {
    return request('/workPlace/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      companyId: any;
      name: any;
      country: any;
      locality: any;
      address: any;
      details: any;
      timetable: any;
      agents: any;
      contactPersons: any;
      workPlaceItems: any;
    }
  ) => {
    const handleFieldValue = (fieldValue: any) => {
      if (Array.isArray(fieldValue)) {
        return fieldValue;
      } else {
        return [fieldValue];
      }
    };

    return request('/workPlace/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          companyId: formData.companyId,
          name: formData.name,
          country: formData.country,
          locality: formData.locality,
          address: formData.address,
          details: formData.details,
          timetable: formData.timetable,
          contactPersons: formData.contactPersons.map((a: any) => ({
            id: a?.id ?? '',
            name: a?.name,
            phone: handleFieldValue(a.phone),
            email: handleFieldValue(a.email),
            isActive: a?.isActive,
            role: handleFieldValue(a.role),
            workPlaceId: a.workPlaceId,
            companyId: a.companyId,
          })),
          agents: formData.agents.map((a: any) => ({
            id: a?.id,
            workPlaceId: a?.workPlaceId,
            userId: a?.userId,
          })),
          //TODO: In future we need crud and sync it with contract.
          workPlaceItems: formData.workPlaceItems,
        },
      }),
    });
  },
};

export default WorkPlaceService;
